import { render, staticRenderFns } from "./EduCourseDianBo.vue?vue&type=template&id=3061781e&scoped=true"
import script from "./EduCourseDianBo.vue?vue&type=script&lang=js"
export * from "./EduCourseDianBo.vue?vue&type=script&lang=js"
import style0 from "./EduCourseDianBo.vue?vue&type=style&index=0&id=3061781e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061781e",
  null
  
)

export default component.exports